var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glass-10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 27",
    style: {
      enableBackground: "new 0 0 20 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.722,0.308C19.533,0.111,19.272,0,19,0H1C0.727,0,0.467,0.111,0.278,0.308C0.09,0.504-0.011,0.77,0.001,1.042L1,25 c0,1.103,0.897,2,2,2h14c1.103,0,2-0.897,1.999-1.958l1-24C20.011,0.77,19.91,0.504,19.722,0.308z M17.957,2l-0.331,7.966 c-0.736-0.078-1.162-0.368-1.694-0.766c-0.713-0.535-1.6-1.2-3.267-1.2s-2.554,0.666-3.267,1.2C8.778,9.665,8.331,10,7.331,10 c-0.999,0-1.446-0.335-2.064-0.8C4.598,8.699,3.768,8.09,2.293,8.015L2.043,2H17.957z M2.999,24.958L2.378,10.034 c0.733,0.079,1.158,0.368,1.688,0.766c0.713,0.535,1.6,1.2,3.266,1.2c1.667,0,2.554-0.666,3.267-1.2c0.62-0.464,1.067-0.8,2.067-0.8 s1.447,0.335,2.067,0.8c0.644,0.483,1.436,1.067,2.809,1.177L17,25L2.999,24.958z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterGlass);
export default __webpack_public_path__ + "static/media/water-glass.be7ee23e7b37731912067b9ec98c1c5c.svg";
export { ForwardRef as ReactComponent };